const steps = [
  {
    step: "01",
    title: "Start Your Secure Order Online",
    desc: "Complete our guided checkout at fastpassportcenter.com. Select your service type, processing speed, and upload a photo of your existing passport (if applicable). Takes under 10 minutes.",
  },
  {
    step: "02",
    title: "We Send Your Personalized Document Checklist",
    desc: "You'll receive a tailored checklist specific to your situation — new passport, renewal, child application, military PCS, or replacement. Includes exactly which documents to send.",
  },
  {
    step: "03",
    title: "Mail Your Documents Overnight to Us",
    desc: "Use FedEx or UPS overnight from O'Fallon or Wentzville (multiple drop-off locations nearby). Documents arrive at our DC office next business day.",
  },
  {
    step: "04",
    title: "We Review & Submit with Reserved Agency Access",
    desc: "Our professional team reviews your entire package before submission. We submit directly to the St. Louis Regional Passport Agency with reserved courier access — no drive downtown for you.",
  },
  {
    step: "05",
    title: "Passport Delivered Overnight to Your Door",
    desc: "Your completed passport is shipped directly to your O'Fallon address overnight. Track every step with live case updates.",
  },
];

export default function OFallonHowItWorksSection() {
  return (
    <section id="how-it-works" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">How It Works</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            How O&apos;Fallon Residents Get an Expedited Passport
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base">
            No office visit. No appointment scramble. As fast as 24 hours from the day your documents arrive.
          </p>
        </div>

        <div className="space-y-6">
          {steps.map((s, i) => (
            <div key={i} className="flex items-start gap-5 bg-white border border-gray-200 rounded-lg p-6">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                <span className="text-[#F6C344] font-bold text-sm">{s.step}</span>
              </div>
              <div>
                <h3 className="font-bold text-[#1A365D] text-base mb-1">{s.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap"
          >
            Start My Passport Today <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}